import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    readOnlyGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(2.5, 4),
        marginBottom: theme.spacing(2.5),
    },
    divider: {
        marginBottom: theme.spacing(2.5),
    },
    deleteZone: {
        marginRight: 'auto',
    },
    title: {
        fontSize: theme.typography.pxToRem(22),
        paddingBottom: theme.spacing(2.5),
    },
    serialField: {
        gridColumn: '1 / -1',
    },
}));
